import querystring from 'querystring';
import { Deferred } from '@/shared/libs';

export default async ({ $deferredLoader }, inject) => {
  $deferredLoader.oneTrust = new Deferred();

  const { _fw_gdpr: gdprApplies, _fw_gdpr_consent: gdprConsent } = querystring.parse(window.location.href.split('?')[1]);

  inject('oneTrust', {
    gdprApplies,
    gdprConsent,
    areConsentsAccepted() {
      return true;
    },
  });

  $deferredLoader.appReady.promise
    .then(() => $deferredLoader.oneTrust.resolve());
};
